import React from 'react'
import CognitoUserList from './abstract/CognitoUserList'
import Config from '../../../Config'
import Loading from '../../../common/component/Loading'

class CompanyUserList extends CognitoUserList {
  constructor (props) {
    super(props)
    this.state = {
      isLoaded: false,
      adminUserList: '',
      isSearched: false,
      targetCategory: '',
      estimationList: [],
      isEditingCategory: false,
      isCategoryModalOpen: false,
      searchName: '',
      searchCategory: '',
      searchDateStart: '',
      searchDateEnd: '',
      currentPage: 1,
      itemsPerPage: 10,
      totalPages: 1,
    }
    this.apiUrl = Config.adminApiUrl.userManagement
    this.userRoleName = '会員企業ユーザ'
    this.userRoleUrl = 'company_user'
    this.userRole = 'companyUser'
  }
  selected (user, e) {
    this.props.history.push('/admin/' + this.userRoleUrl + '/detail/' + this.props.parentID + '/' + user.id)
  }
  render () {
    if (!this.state.isLoaded) {
      return <Loading />
    }
    const userList = this.renderUserList(this.state.userList)
    return (
      <div className='box'>
        <div className='box-header'>
          <i className='icon-info-sign icon-large' />
          <h5>{this.userRoleName}情報</h5>
        </div>
        <div className='box-content box-table'>
          <table className='table table-hover tablesorter'>
            <thead>
              <tr>
                <th>{this.userRoleName}名</th>
                <th>アカウント有効/無効</th>
                <th>企業ユーザーメールアドレス</th>
                <th className='kw-list-date'>作成日時</th>
                <th className='kw-list-date'>最終更新日時</th>
                <th className='kw-list-date'>最終ログイン日時</th>
              </tr>
            </thead>
            <tbody>
              {userList}
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

export default CompanyUserList



// WEBPACK FOOTER //
// ./src/admin/pages/secure/CompanyUserList.js